<i2g-notification
  notificationStyle="alert"
  class="verify-account-notification"
  [showButton]="true"
  [buttonText]="'DIALOG.PAYMENTS.LABEL.RESEND_EMAIL' | translate"
  [showDismissIcon]="false"
  [message]="message"
  (clickButton)="onResendEmail()"
>
</i2g-notification>
